var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((7),function(i){return _c('span',{key:i,class:'mx-1 '+_vm.isActive(i)},[_vm._v(_vm._s(_vm.$t("week")[i-1].short))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }